export default "__VITE_ASSET__DunFkh$S__"